import { z } from 'zod';
// ---------------------------------------------------------------------------
// Seasons
// ---------------------------------------------------------------------------
export const SEASONS = ['spring', 'summer', 'autumn', 'winter'];
export const seasonSchema = z.enum(SEASONS);
export const SEASON_LABELS = {
    spring: { fr: 'Printemps', en: 'Spring' },
    summer: { fr: 'Été', en: 'Summer' },
    autumn: { fr: 'Automne', en: 'Autumn' },
    winter: { fr: 'Hiver', en: 'Winter' },
};
//# sourceMappingURL=seasons.js.map